<template>
  <section
    v-if="loading || errored || reports.length > 0"
    class="tw-flex tw-flex-col"
    data-testid="pinned-reports"
  >
    <div
      class="
        tw-uppercase
        tw-text-center
        tw-text-xs
        tw-tracking-wider
        tw-text-sf-neutral-light-1
        tw-my-4
      "
      data-walkthrough-id="pinned-reports-title"
    >
      {{ I18n.t('report.drawer.pin_to_top.section_title') }}
    </div>
    <PinnedReportCardList
      :reports="reports"
      :loading="loading"
      :errored="errored"
      :expected-count="expectedCount"
      @retry="loadReports"
    />
  </section>
</template>

<script setup lang="ts">
import { nextTick } from 'vue'

import PinnedReportCardList from '@app/application/report/components/pinned-report-card-list.vue'
import { usePinnedReportCards } from '@app/application/report/composables/use-pinned-report-cards'
import { PINNED_CARDS_RENDERED } from '@app/application/report/constants'
import useI18n from '@app/shared/vue/composables/use-I18n'

defineOptions({ name: 'PinnedReports' })

defineProps<{ expectedCount: number }>()

const I18n = useI18n()

const { reports, loading, errored, fetchReports } = usePinnedReportCards()

// A search typed while the fetch ran cannot have filtered these cards: tell
// the reports--index controller they are on the page.
async function loadReports(): Promise<void> {
  await fetchReports()
  await nextTick()
  document.dispatchEvent(new CustomEvent(PINNED_CARDS_RENDERED))
}

void loadReports()
</script>
